import { Box, BoxProps, Text } from 'grommet';
import { ReactNode } from 'react';
import { Recalculating } from './estimate/Recalculating';

/**
 * The two tiers of a session, commercial or estimate card's header: FieldTier holds the record's
 * settings as labelled fields, CostTier under it what it costs.
 */
export const FieldTier = ({ children, ...props }: BoxProps & { children: ReactNode }) => (
  <Box
    direction="row"
    wrap
    gap="small"
    align="end"
    pad={{ vertical: '14px', horizontal: '16px' }}
    border={{ side: 'bottom', color: 'border-divider' }}
    {...props}
  >
    {children}
  </Box>
);

export type TCost = {
  label: string;
  value: ReactNode;
  /** The figure that matters most, in the brand color */
  emphasis?: boolean;
};

export type CostTierProps = {
  /** Left of the costs, e.g. "16 hrs straight · 2 hrs overtime" */
  summary?: ReactNode;
  costs: TCost[];
  /** The costs are being recalculated */
  busy?: boolean;
};

export const CostTier = ({ summary, costs, busy = false }: CostTierProps) => (
  <Box
    direction="row"
    wrap
    justify="between"
    align="center"
    gap="medium"
    background="surface-subtle"
    pad={{ vertical: '12px', horizontal: '16px' }}
  >
    <Text size="small" color="text-secondary">
      {summary}
    </Text>
    <Box direction="row" gap="large">
      {costs.map((cost) => (
        <Box key={cost.label} align="end">
          <Text size="xsmall" color="text-label">
            {cost.label}
          </Text>
          <Recalculating busy={busy}>
            <Text
              size="18px"
              weight={600}
              color={cost.emphasis ? 'brand' : 'text-heading'}
              style={{ fontVariantNumeric: 'tabular-nums' }}
            >
              {cost.value}
            </Text>
          </Recalculating>
        </Box>
      ))}
    </Box>
  </Box>
);
